import { render, staticRenderFns } from "./MultiBarChart.vue?vue&type=template&id=58f486ac&scoped=true"
import script from "./MultiBarChart.vue?vue&type=script&lang=js"
export * from "./MultiBarChart.vue?vue&type=script&lang=js"
import style0 from "./MultiBarChart.vue?vue&type=style&index=0&id=58f486ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f486ac",
  null
  
)

export default component.exports